import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgTourists = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <path d="M8 3q0 1.25-.875 2.125T5 6t-2.125-.875T2 3q0-1.219.875-2.094Q3.75 0 5 0t2.125.906Q8 1.781 8 3zm18 0q0 1.25-.875 2.125T23 6t-2.125-.875T20 3q0-1.219.875-2.094Q21.75 0 23 0t2.125.906Q26 1.781 26 3zM8 8H2q-.844 0-1.406.594Q0 9.188 0 10v10h2v12h2.5V20h1v12H8V20h2V10q0-.813-.563-1.406Q8.843 8 7.999 8zm22.469 8L32 14.906l-4.156-6.438q-.156-.219-.375-.344T27 7.999h-8q-.25 0-.469.125t-.375.344L14 14.906 15.531 16 19 11.531l1.188 2.781L16 22h3.844l.656 10h2V22h1v10h2l.656-10H30l-4.188-7.688L27 11.531z" />
  </svg>
);
const Memo = memo(SvgTourists);
export default Memo;
